import { secureApiCall } from "./authHeader"; 

const API_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_URL) {
    console.error("Error: REACT_APP_BACKEND_URL no está definido.");
}

//Función para enviar el SMS
export const enviarSms = async (smsPayload) => {
  const response = await secureApiCall(
     "api/v1/SMS/EnviarSms",
     "post",
     smsPayload
   );
  return response.data;
};

//ENVIA TOKEN SMS 
export const enviarSmsToken = async (data) => {
  try {
    const payload = {
      operadorId: data.operadorId,
      celular: data.celular,
      message: "",
      senderId: "ALFIN",
      tokenIngresado: "",
      tokenEncriptado: "",
      usado: false,
      correo: data.correo
    };
    const response = await secureApiCall(
      "api/v1/SMS/EnviarSmsToken",
      "post",
      payload,
      false
    );
    return response;
  } catch (error) {
    console.error('Error al enviar SMS token:', error);
    throw error;
  }
};


// VERIFICA EL TOKEN
export const verificarToken = async (data) => {
  try {

    const payload = {
        tokenIngresado: data.tokenIngresado
    };

    const response = await secureApiCall(
      "api/v1/SMS/VerificarToken",
      "post",
      payload,
      false,
      { "Content-Type": "application/json" }
    );
    return response;
  } catch (error) {
    console.error('Error al verificar token:', error);
    throw error;
  }
};